import styled from "styled-components";

export const CoversWrapper = styled.div`
    padding: 12rem 2rem 3rem 2rem;

    @media (max-width: 640px) {
        padding: 0;
    }

    .models-group-container {
        margin-bottom: 2rem;
        position: relative;

        .models-group-name {
            text-transform: capitalize;
            font-size: 2.25rem;
            margin-bottom: 1rem;
            font-weight: ${(props) => props.theme.FontWeightSemibold};
            font-family: "Inter Tight", sans-serif;

            @media (max-width: 640px) {
                font-size: 1.35rem;
                margin-bottom: 0.25rem;
            }
        }

        .models-group-toolbar-icons {
            position: absolute;
            top: 0.25rem;
            right: 1.15rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 1rem;
            font-size: 1.2rem;

            .download-compcards,
            .send-shortlist {
                cursor: pointer;
                opacity: 0.8;

                &:hover {
                    opacity: 1;
                }
                .arrow-down {
                    --fa-primary-color: white;
                    --fa-secondary-color: black;
                    --fa-primary-opacity: 1;
                    --fa-secondary-opacity: 1;
                }
            }
        }

        .models-container {
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;

            .model-cover {
                width: ${(props) => `calc((100%  - ${(props.imagesPerRow - 1) * 1}rem) / ${props.imagesPerRow})`};
                padding-top: 0.5rem;
                padding-bottom: 0.5rem;
                box-sizing: border-box;
                position: relative;

                @media (max-width: 640px) {
                    padding-bottom: 0;
                }

                .model-cover-img-wrapper {
                    width: 100%;
                    aspect-ratio: ${(props) => props.imageAspectRatio};
                    overflow: hidden;
                    cursor: pointer;
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: all 0.2s linear;
                    }

                    .model-features-overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 60;
                        width: 100%;
                        height: 100%;

                        background-color: rgba(0, 0, 0, 0.4);

                        opacity: 0;

                        @media only screen and (max-width: 640px) {
                            display: none;
                        }

                        .model-features {
                            color: #fff;
                            z-index: 251;
                            font-size: 0.9rem;
                            line-height: 1.5em;

                            text-transform: uppercase;
                            position: absolute;
                            top: 1em;
                            left: 1em;
                            width: calc(100% - 2em);

                            @media only screen and (max-width: 640px) {
                                font-size: 0.75em;
                                left: 0.5em;
                                width: calc(100% - 1em);
                            }

                            .model-feature {
                                display: flex;
                                em {
                                    font-style: normal;
                                    font-weight: ${(props) => props.theme.FontWeightBold};
                                    margin-left: auto;
                                }
                            }
                        }
                    }
                }

                .model-name {
                    position: relative;
                    background-color: ${(props) => props.theme.LayoutBodyBackground};
                    color: ${(props) => props.theme.TextColor};
                    width: 100%;
                    margin: 0;
                    padding: 0.15rem 0.15rem 0 0.15rem;
                    height: 3rem;
                    overflow: hidden;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    @media (max-width: 640px) {
                        height: 2rem;
                        width: ${(props) =>
                            `calc((100vw - 3rem - ${props.imagesPerRow * 1}rem) / ${props.imagesPerRow})`};
                    }

                    h3 {
                        line-height: 1.25em;
                        margin: 0;
                        cursor: pointer;
                        font-size: 1.35rem;
                        font-weight: ${(props) => props.theme.FontWeightBase};
                        text-transform: capitalize;

                        @media (max-width: 640px) {
                            font-size: 1rem;
                        }
                    }

                    .model-icons {
                        font-size: 1.25rem;
                        padding-right: 0.5rem;
                        display: flex;
                        gap: 1rem;
                        align-items: center;
                        justify-content: flex-end;

                        @media (max-width: 640px) {
                            font-size: 1rem;
                        }
                    }
                }

                &:hover {
                    .model-cover-img-wrapper {
                        img {
                            transform: scale(1.2);
                        }
                    }
                    .model-name {
                        h3 {
                            font-weight: 400;
                        }
                    }
                    .model-features-overlay {
                        opacity: 1;
                    }
                }
            }

            &.bw {
                .model-cover {
                    .model-cover-img {
                        filter: grayscale(100%);
                    }
                }
            }
        }
    }
`;
